<main class="goals-page">
  <section class="goals__container">
    <header class="goals__header">
      <div>
        <h1>
          {{ 'goals.title' | translate }}
        </h1>
        <p>{{ 'goals.subtitle' | translate }}</p>
      </div>
      <button type="button"
              class="primary-btn"
              *ngIf="canManageGoals"
              (click)="openCreatePanel()">
        {{ 'goals.actions.new' | translate }}
      </button>
    </header>


    <div class="goals__toolbar">
      <div class="toolbar-summary">
        <div class="status-pills">
          <button
            *ngFor="let status of availableStatuses"
            type="button"
            class="status-pill"
            [class.is-active]="statusFilters[status.id]"
            [style.--status-color]="statusColors[status.id]"
            [attr.aria-pressed]="statusFilters[status.id]"
            [attr.title]="status.labelKey | translate"
            (click)="toggleStatusFilter(status.id)">
            <span class="status-pill__count" aria-hidden="true">{{ statusCounts[status.id] || 0 }}</span>
            <span class="status-pill__label">{{ status.labelKey | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="goals__filters surface-card">
      <div class="goals__filter-field">
        <label>{{ 'goals.filters.search' | translate }}</label>
        <div class="goals__filter-control">
          <input type="search"
                 [value]="searchTerm"
                 [placeholder]="'goals.filters.searchPlaceholder' | translate"
                 (input)="onSearch($any($event.target).value)">
        </div>
      </div>
    </div>

    <div class="goals__layout">
      <div class="goals__card surface-card">
        <div class="goals__table-wrapper">
          <div class="goals__table-header"
               [class.goals__table-header--advanced]="advanced"
               *ngIf="!isLoading && !loadingError && filteredGoals.length">
            <span>{{ 'goals.table.description' | translate }}</span>
            <span>{{ 'goals.table.owner' | translate }}</span>
            <span>{{ 'goals.table.type' | translate }}</span>
            <span>TNCIDs</span>
            <span *ngIf="advanced">{{ 'goals.table.events' | translate }}</span>
            <span *ngIf="advanced">{{ 'goals.table.trend' | translate }}</span>
            <span>{{ 'goals.table.status' | translate }}</span>
            <span class="goals__header-spacer" aria-hidden="true"></span>
          </div>
          <div class="goals__list">
            <p class="list-status" *ngIf="isLoading">{{ 'goals.states.loading' | translate }}</p>
            <p class="list-status error" *ngIf="!isLoading && loadingError">{{ loadingError }}</p>

            <ng-container *ngIf="!isLoading && !loadingError && filteredGoals.length; else goalsState">
              <div class="goals__row" [class.goals__row--advanced]="advanced" *ngFor="let goal of paginatedGoals">
                <span>
                  <div class="goals__cell-title">
                    {{ goal.description }}
                    <!--
                      Solo informativo: un'estrazione e' partita (notturna o on-demand) ma non
                      risulta mai conclusa, e la finestra di guardia e' scaduta. Non blocca nulla:
                      Recalculate resta la via di recupero (ripete il DELETE+INSERT lasciato a meta').
                    -->
                    <svg *ngIf="goal.isExtractionStalled"
                         class="goals__stalled-icon"
                         viewBox="0 0 20 20"
                         role="img"
                         [attr.aria-label]="'goals.warnings.extractionStalled' | translate">
                      <title>{{ 'goals.warnings.extractionStalled' | translate }}</title>
                      <path d="M10 2.5 18 17H2z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
                      <rect x="9.25" y="7.5" width="1.5" height="4.5" rx="0.75" fill="currentColor"/>
                      <circle cx="10" cy="14" r="0.9" fill="currentColor"/>
                    </svg>
                  </div>
                </span>
                <span class="goals__owner">
                  <div class="goals__owner-name">{{ goal.entity }}</div>
                </span>
                <span>
                  <strong>{{ goal.typeName }}</strong>
                </span>
                <!--
                  Spinner al posto del numero mentre si attendono TNCIDs/Events/trend dopo
                  un'estrazione riuscita (vedi pollForFreshData): quei dati passano da un
                  caricamento esterno la cui tempistica non e' garantita, quindi "-" da solo
                  sarebbe indistinguibile da "nessun dato" invece che "sta arrivando".
                -->
                <ng-template #dataSpinner>
                  <svg class="goals__data-spinner" viewBox="0 0 24 24" role="img"
                       [attr.aria-label]="'goals.states.dataPending' | translate">
                    <title>{{ 'goals.states.dataPending' | translate }}</title>
                    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="3"
                            stroke-dasharray="34 60" stroke-linecap="round"/>
                  </svg>
                </ng-template>
                <span>
                  <strong *ngIf="!awaitingFreshData.has(goal.id); else dataSpinner">{{ formatVolume(goal.totalTNCIDs) }}</strong>
                </span>
                <span *ngIf="advanced">
                  <strong *ngIf="!awaitingFreshData.has(goal.id); else dataSpinner">{{ formatVolume(goal.totalEvents) }}</strong>
                </span>
                <span *ngIf="advanced" class="goals__trend-cell">
                  <ng-container *ngIf="!awaitingFreshData.has(goal.id); else dataSpinner">
                    <svg *ngIf="hasTrend(goal)" class="goals__sparkline" viewBox="0 0 100 28" preserveAspectRatio="none" aria-hidden="true">
                      <polyline [attr.points]="sparklinePoints(goal)" fill="none" stroke="#2563eb" stroke-width="1.5" />
                    </svg>
                    <span *ngIf="!hasTrend(goal)" class="goals__trend-empty">—</span>
                  </ng-container>
                </span>
                <span>
                  <div class="goals__active-cell">
                    <label class="goals__toggle">
                      <input type="checkbox"
                             [checked]="goal.status === 'active'"
                             (change)="toggleActivation(goal)">
                      <span class="goals__toggle-slider"></span>
                    </label>
                  </div>
                </span>
                <div class="goals__actions">
                  <button type="button"
                          class="goals__action-trigger"
                          aria-haspopup="menu"
                          [attr.aria-expanded]="activeActionMenuId === goal.id"
                          (click)="toggleActionsMenu(goal, $event)">
                    <svg viewBox="0 0 20 20" role="presentation" aria-hidden="true">
                      <circle cx="10" cy="4" r="1.5" />
                      <circle cx="10" cy="10" r="1.5" />
                      <circle cx="10" cy="16" r="1.5" />
                    </svg>
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-template #goalsState>
              <p class="list-status" *ngIf="!isLoading && !loadingError && !filteredGoals.length">
                {{ 'goals.states.empty' | translate }}
              </p>
            </ng-template>
          </div>
        </div>

        <div class="pagination-controls" *ngIf="!isLoading && filteredGoals.length">
          <div class="page-size">
            <label>{{ 'goals.pagination.rowsPerPage' | translate }}</label>
            <select [value]="pageSize" (change)="changePageSize($event)">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
          </div>
          <div class="page-navigation">
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage === 0">
              ‹
            </button>
            <span class="page-info">
              {{ 'goals.pagination.page' | translate:{ current: ((currentPage + 1) | number:'1.0-0':locale), total: (totalPages | number:'1.0-0':locale) } }}
            </span>
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage + 1 >= totalPages">
              ›
            </button>
          </div>
        </div>

        <ng-container *ngIf="activeActionItem as menuItem">
          <div class="goals__action-menu"
               [class.goals__action-menu--above]="actionMenuPlacement === 'above'"
               role="menu"
               [style.top.px]="actionMenuPosition.top"
               [style.left.px]="actionMenuPosition.left"
               [style.--goals-action-arrow-left]="actionMenuArrowOffset + 'px'">
            <div class="goals__action-menu-label">{{ 'goals.actions.menuTitle' | translate }}</div>
            <!-- Edit, ricalcolo e cancellazione sono inibiti durante un'estrazione:
                 vedi settings/goals/lib/extraction-lock.ts per il perche'. Il toggle di
                 stato resta attivo, non tocca ne' la regola ne' i dati estratti. -->
            <button type="button"
                    class="goals__action-item"
                    *ngIf="canManageGoals"
                    [disabled]="menuItem.isExtracting"
                    [title]="menuItem.isExtracting ? ('goals.actions.extractionRunning' | translate) : ''"
                    (click)="openEditPanel(menuItem)">
              <span class="action-icon action-icon--edit" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M3 14.5V17h2.5L15.4 7.1l-2.5-2.5L3 14.5z" />
                  <path d="M12.2 4.1l2.5 2.5 1.4-1.4c.4-.4.4-1 0-1.4L14 2.2c-.4-.4-1-.4-1.4 0l-1.4 1.9z" />
                </svg>
              </span>
              <span>{{ 'goals.actions.edit' | translate }}</span>
            </button>
            <button type="button" class="goals__action-item" *ngIf="canManageGoals" (click)="toggleActivation(menuItem)">
              <span class="action-icon action-icon--pause" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <rect x="6" y="4" width="2.5" height="12" rx="1" />
                  <rect x="11.5" y="4" width="2.5" height="12" rx="1" />
                </svg>
              </span>
              <span>
                {{ menuItem.status === 'active' ? ('goals.actions.deactivate' | translate) : ('goals.actions.activate' | translate) }}
              </span>
            </button>
            <button type="button" class="goals__action-item"
                    *ngIf="canManageGoals"
                    [disabled]="menuItem.isExtracting"
                    [title]="menuItem.isExtracting ? ('goals.actions.extractionRunning' | translate) : ''"
                    (click)="openRecalculateModal(menuItem)">
              <span class="action-icon action-icon--recalculate" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M16 10c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6c1.8 0 3.4.8 4.5 2.1V4" stroke="currentColor" stroke-width="1.5" fill="none"/>
                  <path d="M16 4v3h-3" stroke="currentColor" stroke-width="1.5" fill="none"/>
                </svg>
              </span>
              <span>{{ 'goals.actions.recalculate' | translate }}</span>
            </button>
            <button type="button" class="goals__action-item"
                    *ngIf="advanced && hasTrend(menuItem)"
                    (click)="downloadTrendCsv(menuItem)">
              <span class="action-icon action-icon--download" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M10 3v9M6 9l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none"/>
                  <path d="M4 15h12" stroke="currentColor" stroke-width="1.5" fill="none"/>
                </svg>
              </span>
              <span>{{ 'goals.actions.downloadTrend' | translate }}</span>
            </button>
            <button type="button" class="goals__action-item danger"
                    *ngIf="canManageGoals"
                    [disabled]="menuItem.isExtracting"
                    [title]="menuItem.isExtracting ? ('goals.actions.extractionRunning' | translate) : ''"
                    (click)="deleteGoal(menuItem)">
              <span class="action-icon action-icon--delete" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M6 6h8l-.8 10.5H6.8L6 6z" />
                  <path d="M4 5h12" />
                  <path d="M8 5V3h4v2" />
                </svg>
              </span>
              <span>{{ 'goals.actions.delete' | translate }}</span>
            </button>
          </div>
        </ng-container>
      </div>

      <div class="goals__form-wrapper" *ngIf="panelOpen">
        <app-goals-form
          #goalForm
          [goalTypes]="goalTypes"
          [customVariables]="customVariables"
          [hasGlobalDataScope]="hasGlobalDataScope"
          [ownerEntityOptions]="ownerEntityOptions"
          [advanced]="advanced"
          (saved)="handleFormSaved($event)"
          (cancelled)="closePanel()"
        ></app-goals-form>
      </div>
    </div>
  </section>
</main>

<div class="modal-backdrop" *ngIf="recalculateModalOpen">
  <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
    <header class="modal-header">
      <div>
        <h3>{{ 'goals.actions.recalculate' | translate }}</h3>
        <p>{{ 'goals.actions.recalculateConfirm' | translate:{ name: recalculateModalTarget?.description } }}</p>
      </div>
      <button type="button" class="ghost-btn compact" aria-label="{{ 'goals.actions.cancel' | translate }}" (click)="closeRecalculateModal()">×</button>
    </header>
    <footer class="modal-actions">
      <button type="button" class="ghost-btn" (click)="closeRecalculateModal()">
        {{ 'goals.actions.cancel' | translate }}
      </button>
      <!-- Nessuno stato "in corso": la modale si chiude appena l'estrazione è partita. -->
      <button type="button" class="primary-btn" (click)="performRecalculate()">
        {{ 'goals.actions.recalculate' | translate }}
      </button>
    </footer>
  </div>
</div>

<div class="modal-backdrop" *ngIf="deleteModalOpen">
  <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
    <header class="modal-header">
      <div>
        <h3>{{ 'goals.actions.delete' | translate }}</h3>
        <p>{{ 'goals.actions.deleteConfirm' | translate:{ name: deleteModalTarget?.description } }}</p>
      </div>
      <button type="button" class="ghost-btn compact" aria-label="{{ 'goals.actions.cancel' | translate }}" (click)="closeDeleteModal()">×</button>
    </header>
    <footer class="modal-actions">
      <button type="button" class="ghost-btn" (click)="closeDeleteModal()">
        {{ 'goals.actions.cancel' | translate }}
      </button>
      <button type="button"
              class="primary-btn danger"
              (click)="confirmDelete()">
        {{ 'goals.actions.delete' | translate }}
      </button>
    </footer>
  </div>
</div>
